import React from 'react';
import { Slider, Typography, Form } from 'antd';

import { expirationIndexToReadable, daysToExpirationIndex } from '../utils/expirationIndexToReadable';

function formatHours(hours: number) {
  if (hours > 24) return `${hours / 24} days`;
  return `${hours} hours`;
}

function formatSliderLabel(days: number, sliderIndex: number) {
  return days <= 1 ? `${sliderIndex}h` : `${days}d`;
}

type CacheExpirationSliderProps = {
  daysInterval: [number, number]; // [number, number]
  value: number; //hours
  label: string;
  disabled?: boolean;
};

// first part is hours, then days.
// so it could be 1h ... 24h, 2d ... 30d
function CacheExpirationSlider({ daysInterval, value, label, disabled }: CacheExpirationSliderProps) {
  const [startDay, endDay] = daysInterval;
  const minCacheExpirationIndex = daysToExpirationIndex(startDay);
  const maxCacheExpirationIndex = daysToExpirationIndex(endDay);

  if (startDay === endDay) {
    return (
      <Form.Item name="cacheExpirationHours" label={label}>
        <Typography.Text>{formatHours(value)}</Typography.Text>
      </Form.Item>
    );
  }

  return (
    <Form.Item name="cacheExpirationHours" label={label}>
      <Slider
        min={minCacheExpirationIndex}
        max={maxCacheExpirationIndex}
        marks={{
          [minCacheExpirationIndex]: formatSliderLabel(startDay, minCacheExpirationIndex),
          [maxCacheExpirationIndex]: formatSliderLabel(endDay, maxCacheExpirationIndex),
        }}
        tooltip={{ formatter: expirationIndexToReadable }}
        disabled={disabled}
      />
    </Form.Item>
  );
}

export default CacheExpirationSlider;
